














import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class NumberInfo extends Vue {
  @Prop() private title: string;
  @Prop() private subTitle: string;
  @Prop() private suffix: any;
  @Prop() private total: any;
  @Prop() private status: any;
  @Prop() private subTotal: any;
}
